import React, { useRef, useState } from "react";

import { Header } from "./Header"; // or wherever Header is defined
import { CardContainer } from "./CardContainer";
import { ScrollableSectionProps } from "./types";

const ScrollableSection = ({
  providers,
  icon,
  title,
  viewAllUrl,
}: ScrollableSectionProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [scrollState, setScrollState] = useState({ left: false, right: true });

  const updateScrollState = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } =
        scrollContainerRef.current;
      setScrollState({
        left: scrollLeft > 0,
        right: scrollLeft + clientWidth < scrollWidth,
      });
    }
  };

  const handleScroll = (direction: "left" | "right") => {
    if (scrollContainerRef.current) {
      const scrollAmount = 300;
      const newScrollPosition =
        direction === "left"
          ? scrollContainerRef.current.scrollLeft - scrollAmount
          : scrollContainerRef.current.scrollLeft + scrollAmount;

      scrollContainerRef.current.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
    }
  };

  const sectionId = `section-${viewAllUrl}`;

  return (
    <div className="col-4" id={sectionId}>
      <Header
        icon={icon}
        title={title}
        viewAllUrl={viewAllUrl}
        onScrollLeft={() => handleScroll("left")}
        onScrollRight={() => handleScroll("right")}
        scrollState={scrollState}
      />
      <div
        ref={scrollContainerRef}
        className="overflow-x-auto whitespace-nowrap"
        style={{ scrollbarWidth: "none" }}
        onScroll={updateScrollState}
      >
        <CardContainer cardData={providers} url={viewAllUrl} />
      </div>
    </div>
  );
};

export default ScrollableSection;
